import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useParams} from 'react-router-dom';
import GoBackButton from "../layout/GoBackButton";
import {getSparePart} from "../../actions/spare_part";

const SparePartPage = () => {

    useEffect(() => {
        dispatch(getSparePart(id));
    }, [getSparePart]);

    const dispatch = useDispatch();

    const {id} = useParams();

    const {spare_part} = useSelector(state => state.spare_part);

    return (
        <div>
            <main className="content mt-0 pt-0">
                <div className="container-fluid p-0">

                    <div className="row mb-2">
                        <div className="col-md-12 col-lg-8">
                            <h1 className="h3 mb-3"><strong>Ehtiyot qismi</strong> sahifasi </h1>
                        </div>
                        <div className="col-lg-4">
                            <div className="crud_actions text-end">
                                <GoBackButton/>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 col-lg-12">
                            <div className="card px-4 py-3">
                                Ehtiyot qismi nomi:  {spare_part?.name}
                            </div>
                        </div>
                    </div>

                </div>
            </main>
        </div>
    );
};

export default SparePartPage;